import { makeStyles, Theme } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) => ({
  dialogRoot: {
    "&.base-dialog-root": {
      minWidth: "640px",
      "@media (max-width: 680px)": {
        minWidth: "unset",
        width: "calc(100% - 32px)",
        margin: "auto"
      }
    }
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    padding: "1.5rem 1rem"
  },
  icon: {
    marginBottom: "1rem"
  },
  message: {
    maxWidth: 560
  }
}));

export default useStyles;
